.network-search-item {
  display: flex;
}

.tree-search-result {
  max-height: 600px;
  overflow-y: auto;
  padding-left: var(--spacer);
}

.tree-no-search-result {
  font-family: var(--font-family-secondary);
  font-size: var(--body-size-large);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
}

.search-header {
  display: flex;
  align-items: center;
  padding-left: var(--network-tree-input-padding, var(--spacer));
  margin-top: 10px;
  margin-bottom: 15px;
}

gz-list-item {
  padding-left: var(--spacer);
  padding-right: var(--spacer);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

gz-loader {
  --loader-height: calc(var(--spacer) * 2);
  margin-bottom: var(--spacer);
}
